import React, { useState } from 'react';
import PropTypes from 'prop-types';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import { Grid, Typography } from '@mui/material';
import Box from '@mui/material/Box';

import RedCircleAlertIcon from '../../../../assets/icons/RedCircleAlertIcon';
import { RED } from '../../../../theme/colorConstants';
import { epochToDateInReadableFormat, epochToTimeInReadableFormat } from '../../../../utils';

import RosterCardContainer from './RosterCardContainer';
import RosterCardMoreButton from './RosterCardMoreButton';
import rosterPropTextStyles from './rosterCardSharedStyles';
import WorkerReportButton from './WorkerReportButton';

const CancelledEmployeeRosterCard = ({
  placement,
  onManageCandidate,
  handleOnCancelledPlacementClick,
  onFavoriteClick,
}) => {
  const [isWorkerReportOpen, setIsWorkerReportOpen] = useState(false);
  const showCancellationAlert = Boolean(
    placement?.cancelledWithin24Hours && placement?.candidateCancelled
  );

  return (
    <RosterCardContainer
      dataTestId="cancelledRosterCard"
      isFavorite={placement?.isFavorite}
      reliabilityScore={placement?.reliabilityScore}
      rawReliability={placement?.rawReliability}
      rawAls={placement?.rawAls}
      isPriorityResourcePool={placement?.isPriorityResourcePool}
      firstTimeWorkingThisCustomer={placement?.firstTimeWorkingThisCustomer}
      gpsData={placement?.gpsData}
      gpsPings={placement?.gpsPings}
      employeeName={placement?.employeeName}
      employeeId={placement?.employeeId}
      agencyId={placement?.agencyId}
      profilePictureSrc={placement?.employeeProfilePicture}
      avatarAlt={placement?.employeeName}
      isWorkerReportOpen={isWorkerReportOpen}
      onFavoriteClick={onFavoriteClick}
      employeePhoneNumber={placement?.employeePhoneNumber}
    >
      <Grid item>
        <Grid container alignItems="center" gap="12px">
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography sx={rosterPropTextStyles}>
              {LanguageConverter('jobOrder.roster.cancellationTime')}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '8px',
                alignItems: 'center',
                height: '100%',
              }}
            >
              {showCancellationAlert && <RedCircleAlertIcon />}

              <Typography
                sx={{
                  display: 'flex',
                  fontSize: '14px',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  ...(showCancellationAlert && { color: RED[80] }),
                }}
                onClick={() => handleOnCancelledPlacementClick(placement)}
              >
                {placement?.cancelledDate
                  ? `${epochToDateInReadableFormat(
                      placement.cancelledDate
                    )} at ${epochToTimeInReadableFormat(placement.cancelledDate)}`
                  : '--'}
              </Typography>
            </Box>
          </Box>
          <WorkerReportButton
            isOpen={isWorkerReportOpen}
            onClick={() => setIsWorkerReportOpen((prev) => !prev)}
          />
          <RosterCardMoreButton
            onClick={onManageCandidate}
            ariaLabel={LanguageConverter('jobOrder.roster.viewMore')}
          />
        </Grid>
      </Grid>
    </RosterCardContainer>
  );
};

CancelledEmployeeRosterCard.propTypes = {
  placement: PropTypes.shape({
    id: PropTypes.string,
    employeeId: PropTypes.string,
    employeeName: PropTypes.string,
    employeePhoneNumber: PropTypes.string,
    agencyId: PropTypes.string,
    employeeProfilePicture: PropTypes.string,
    isFavorite: PropTypes.bool,
    cancelledDate: PropTypes.number,
    cancelledWithin24Hours: PropTypes.bool,
    candidateCancelled: PropTypes.bool,
    reliabilityScore: PropTypes.number,
    rawReliability: PropTypes.number,
    rawAls: PropTypes.number,
    isPriorityResourcePool: PropTypes.bool,
    firstTimeWorkingThisCustomer: PropTypes.bool,
    gpsData: PropTypes.shape({ onsite: PropTypes.bool }),
    gpsPings: PropTypes.arrayOf(PropTypes.shape({ onsite: PropTypes.bool })),
    status: PropTypes.string,
  }),
  onManageCandidate: PropTypes.func,
  handleOnCancelledPlacementClick: PropTypes.func,
  onFavoriteClick: PropTypes.func,
};

export default CancelledEmployeeRosterCard;
